import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import { userRoles } from '../../constants/constants';
import { WithRole } from '..';
import InboxListItem from './InboxListItem';
import {
  caseStatus, MODAL_CONFIRM_ACTIVATE_CASE,
  MODAL_CONFIRM_DELETE_CASE,
} from '../../constants';
import {
  archiveCase,
  deleteCase,
  showConfirmModal,
  unarchiveCase,
} from '../../redux/actions';

class InboxList extends Component {
  handleDelete = (_case) => {
    this.props.showConfirmModal(MODAL_CONFIRM_DELETE_CASE, {
      onConfirm: () => {
        if (_case.status.workflowStatus === caseStatus.workflowStatus.CREATE) {
          this.props.deleteCase(_case);
        } else {
          this.props.archiveCase(_case);
        }
      },
    });
  };

  handleActivation = (_case) => {
    this.props.showConfirmModal(MODAL_CONFIRM_ACTIVATE_CASE, {
      onConfirm: () => {
        this.props.unarchiveCase(_case);
      },
    });
  };


  render() {
    const {
      cases,
      selectedCaseId,
      handleCaseSelected,
      displayArchived,
      handleCollapse,
      user,
    } = this.props;


    const shouldDisplayPathalogistsAnalyzes = (_case) => {
      const isSurgeonOrAdmin = (user.role === userRoles.surgeon || user.role === userRoles.admin);
      const { ANALYSIS_SUBMITTED } = caseStatus.workFlowStatusDemo;
      const hasSubmittedAnalyses = _case.status.workFlowStatusDemo === ANALYSIS_SUBMITTED;
      return isSurgeonOrAdmin && hasSubmittedAnalyses;

    }

    return (
      <List className="sidebar__list">
        {cases.map(_case => {
          const inboxListItemSharedProps = {
            id: _case.id,
            isSelected: selectedCaseId === _case.id,
            title: _case.title,
            _case,
            handleCaseSelected,
            handleCollapse,
            //shouldRenderPatologistSelector: shouldDisplayPathalogistsAnalyzes(_case),
            shouldRenderPatologistSelector: false, // might use above in future for multi pathologist 
          };

          if (_case.status.archiveStatus === caseStatus.archiveStatus.ARCHIVED && displayArchived) {
            return (
              <InboxListItem
                {...inboxListItemSharedProps}
                key={_case.id}
                handleActivation={this.handleActivation}
                sidebarActionButtonClass="sidebar__item-activate"
                actionButtonTitle="Unarchive"
              />
            );
          }
          if (_case.status.archiveStatus !== caseStatus.archiveStatus.ARCHIVED && !displayArchived) {
            return (
              /* Renders the archive or delete button on each case
              if user is admin otherwise only delete */
              <WithRole
                key={_case.id}
                render={(role) => ((role === userRoles.admin || role === userRoles.surgeon)
                  ? (
                    <InboxListItem
                      {...inboxListItemSharedProps}
                      sidebarActionButtonClass={`sidebar__item-${_case.status.workflowStatus === caseStatus.workflowStatus.CREATE ? 'delete' : 'archive'}`}
                      actionButtonTitle="Archive"
                      handleDelete={this.handleDelete}
                    />
                  ) : (
                    <InboxListItem
                      {...inboxListItemSharedProps}
                      sidebarActionButtonClass={`sidebar__item-${_case.status.workflowStatus === caseStatus.workflowStatus.CREATE ? 'delete' : 'hidden'}`}
                      handleDelete={this.handleDelete}
                    />
                  ))
                }
              />
            );
          }
          return null;
        })}
      </List>
    );
  }
}

InboxList.propTypes = {
  cases: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedCaseId: PropTypes.string,
  handleCaseSelected: PropTypes.func.isRequired,
};

InboxList.defaultProps = {
  selectedCaseId: '',
};

const mapStateToProps = ({ auth }) => ({ user: auth.user });

export default connect(mapStateToProps, {
  deleteCase,
  archiveCase,
  unarchiveCase,
  showConfirmModal,
})(InboxList);
